module.exports = __webpack_public_path__ + "media/images/athletes/1172-730994b86a54b8d3dc53dadbc7e944da.png";